import { Form, Formik } from 'formik';
import { Button, Modal, Form as FormBootstrap, FormCheck } from 'react-bootstrap';
import { MESSAGE } from 'src/app/modules/utils/Constant';
import * as Yup from 'yup';
import { IconButtonSave } from '../../../component/IconSvg';
import TextField from '../../../component/TextField';

type Props = {
	open: boolean;
	handleClose: () => void;
	onSave?: (data: IForm) => void;
};

type IForm = {
	name: string;
	isGeneral?: boolean;
};

const validationSchema = Yup.object({
	name: Yup.string().required(MESSAGE.REQUIRED),
});

const SaveTemplateModal = ({ open, handleClose, onSave }: Props) => {
	const onSubmit = (values: IForm) => {
		onSave?.(values);
	};

	return (
		<Modal show={open} animation centered>
			<Formik<IForm>
				initialValues={{
					name: '',
					isGeneral: false
				}}
				validationSchema={validationSchema}
				onSubmit={onSubmit}
			>
				{({ values, setFieldValue }) => (
					<Form>
						<Modal.Header className="py-3 header-modal">
							<Modal.Title className="text-pri">Lưu mẫu mới</Modal.Title>
							<Button className="btn-close bg-white" onClick={handleClose}></Button>
						</Modal.Header>

						<Modal.Body className="py-16 px-24 spaces">
							<div className="spaces my-15">
								<TextField
									label="Tên mẫu"
									name="name"
									labelClassName="pe-10 spaces min-w-100"
								/>
								<FormBootstrap.Group
									className={`spaces pt-10 form-check-label-black d-flex flex-end`}
								>
									<FormCheck
										name={"isGeneral"}
										type="checkbox"
										label={"Mẫu chung"}
										className={`d-flex align-items-center spaces gap-7`}
										checked={values.isGeneral}
										onChange={(e: any) =>
											setFieldValue('isGeneral', e.target.checked)
										}
									/>
								</FormBootstrap.Group>
							</div>
						</Modal.Body>

						<Modal.Footer className="d-flex justify-content-end">
							<Button onClick={handleClose}>Đóng</Button>
							<Button type="submit">
								<IconButtonSave />
								Lưu
							</Button>
						</Modal.Footer>
					</Form>
				)}
			</Formik>
		</Modal>
	);
};

export default SaveTemplateModal;
